import * as React from "react";

function DragHandleIcon(props) {
  return (
    <svg viewBox="0 0 16 16" fill="currentColor" {...props}>
      <circle cx="5" cy="3.5" r="1.1" />
      <circle cx="11" cy="3.5" r="1.1" />
      <circle cx="5" cy="8" r="1.1" />
      <circle cx="11" cy="8" r="1.1" />
      <circle cx="5" cy="12.5" r="1.1" />
      <circle cx="11" cy="12.5" r="1.1" />
    </svg>
  );
}

export default DragHandleIcon;
